import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  Badge,
  makeStyles,
  Popover,
  PopoverTrigger,
  PopoverSurface,
  Subtitle1,
} from '@fluentui/react-components';
import { statuses } from './statuses';

const useStyles = makeStyles({
  popoverContent: {
    maxWidth: '500px',
  },
});

export const StatusBadge = ({
  code,
  infoTextData,
  text,
}) => {
  const i18n = useContext(I18nContext);
  const styles = useStyles();

  return (
    <Popover
      positioning="after"
      withArrow
    >
      <PopoverTrigger disableButtonEnhancement>
        <Badge
          appearance="tint"
          color={statuses[code].badgeColor}
        >
          {i18n.getString(text)}
        </Badge>
      </PopoverTrigger>
      <PopoverSurface tabIndex={-1}>
        <div className={styles.popoverContent}>
          <Subtitle1>{i18n.getString(statuses[code].infoTitle)}</Subtitle1>
          <p>{i18n.getString(statuses[code].infoText, infoTextData)}</p>
        </div>
      </PopoverSurface>
    </Popover>
  );
};

StatusBadge.propTypes = {
  code: PropTypes.oneOf(Object.keys(statuses)).isRequired,
  infoTextData: PropTypes.shape({
    name: PropTypes.string,
    startDate: PropTypes.string,
  }).isRequired,
  text: PropTypes.string.isRequired,
};
